import { BsThreeDotsVertical } from "react-icons/bs";
import { DropDownComp } from "../../Ui/selectComp";

/**
 * Standard three-dot row actions menu — matches loan/contribution admin tables.
 */
export default function TableActionDropdown({ items = [], row }) {
  if (!items?.length) return null;

  return (
    <div className="text-center">
      <DropDownComp
        dropLabelClassName="bg-white border-0 px-3 py-1 rounded-4"
        arrayComp={items}
        ItemClassName="pe-5 text-2"
        input="name"
        row={row}
        DropDownText={
          <span style={{ cursor: "pointer" }} aria-label="Row actions">
            <BsThreeDotsVertical size={20} className="table-action-icon" />
          </span>
        }
      />
    </div>
  );
}
